import { WhatsAppTemplatesTable } from "components";

const WhatsAppTemplates = () => {
    return (
        <WhatsAppTemplatesTable />
    );
}

export default WhatsAppTemplates;
